function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-split-content\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.11,29.31h-8.5a2.86,2.86,0,0,1,0-5.72h8.5a2.86,2.86,0,0,1,0,5.72Zm-8.5-3.58a.72.72,0,0,0,0,1.44h8.5a.72.72,0,1,0,0-1.44Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.54,33.74H4.2a4,4,0,0,1-4-4V9.37a4,4,0,0,1,4-4H16.54a4,4,0,0,1,4,4V29.76A4,4,0,0,1,16.54,33.74ZM4.2,7.52A1.85,1.85,0,0,0,2.35,9.37V29.76A1.85,1.85,0,0,0,4.2,31.61H16.54a1.85,1.85,0,0,0,1.85-1.85V9.37a1.85,1.85,0,0,0-1.85-1.85Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.72,26.83a1.12,1.12,0,0,1-.64-2l3.6-2.46a4.26,4.26,0,0,1,4.83,0l1.74,1.17a2,2,0,0,0,2.69-.37L18.2,18a1.13,1.13,0,0,1,1.72,1.46l-4.26,5a4.28,4.28,0,0,1-5.66.79L8.25,24.16a2,2,0,0,0-2.29,0L2.35,26.64A1.11,1.11,0,0,1,1.72,26.83Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11,20.34a4.47,4.47,0,1,1,4.47-4.47A4.47,4.47,0,0,1,11,20.34Zm0-6.68a2.22,2.22,0,1,0,2.22,2.21A2.21,2.21,0,0,0,11,13.66Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.55,11.55H25.18a1.07,1.07,0,1,1,0-2.13H38.55a1.07,1.07,0,0,1,0,2.13Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M38.55,17.84H25.18a1.07,1.07,0,0,1,0-2.14H38.55a1.07,1.07,0,0,1,0,2.14Z",
  fill: "#231f20"
});

function SvgCmsSplitContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgCmsSplitContent;